import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthService, UtilService } from '..';

export interface IResponsePayload<T> {
  success: boolean;
  message: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class HttpService {
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private utils: UtilService
  ) {}

  get<T>(url: string): Promise<IResponsePayload<T>> {
    const headers = this.getAuthHeaders();
    const observable = this.http.get<IResponsePayload<T>>(url, { headers });
    return this.utils.toPromise(observable);
  }

  post<T>(url: string, body: any): Promise<IResponsePayload<T>> {
    const headers = this.getAuthHeaders();
    const observable = this.http.post<IResponsePayload<T>>(url, body, {
      headers,
    });
    return this.utils.toPromise(observable);
  }

  postWithFile<T>(
    url: string,
    body: any,
    file?: File
  ): Promise<IResponsePayload<T>> {
    const headers = this.getAuthFileHeaders();
    const formData = new FormData();
    if (file) formData.append('file', file);
    formData.append('data', JSON.stringify(body));
    const observable = this.http.post<IResponsePayload<T>>(url, formData, {
      headers,
    });
    return this.utils.toPromise(observable);
  }

  put<T>(url: string, body: any): Promise<IResponsePayload<T>> {
    const headers = this.getAuthHeaders();
    const observable = this.http.put<IResponsePayload<T>>(url, body, {
      headers,
    });
    return this.utils.toPromise(observable);
  }

  putWithFile<T>(
    url: string,
    body: any,
    file?: File
  ): Promise<IResponsePayload<T>> {
    const headers = this.getAuthFileHeaders();
    const formData = new FormData();
    if (file) formData.append('file', file);
    formData.append('data', JSON.stringify(body));
    const observable = this.http.put<IResponsePayload<T>>(url, formData, {
      headers,
    });
    return this.utils.toPromise(observable);
  }

  delete<T>(url: string): Promise<IResponsePayload<T>> {
    const headers = this.getAuthHeaders();
    const observable = this.http.delete<IResponsePayload<T>>(url, { headers });
    return this.utils.toPromise(observable);
  }

  private getAuthHeaders(): HttpHeaders {
    const token = this.auth.getToken();
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  private getAuthFileHeaders(): HttpHeaders {
    const token = this.auth.getToken();
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }
}
